import styled, { css } from 'styled-components';

interface IDateContainerProps {
  $disabled: boolean;
  $alignItems?: string;
}
export const DateContainer = styled.div<IDateContainerProps>`
  display: flex;

  background: ${({ $disabled }) => ($disabled ? '#ccc' : 'transparent')};
  border-radius: 0.5rem;

  align-items: ${({ $alignItems }) => $alignItems || 'center'};
  justify-content: space-around;
  gap: 6px;

  & .MuiFormControl-root {
    width: 100%;
  }

  @media (max-width: 560px) {
    flex-direction: column;
    & .MuiFormControl-root {
      width: 100%;
      margin: 0.25rem 0rem;
    }
  }
`;

interface IBoxInputDataProps {
  $isDisabled: boolean;
  $hasBackground?: boolean;
}
export const BoxInputData = styled.div<IBoxInputDataProps>`
  width: 100%;
  & .MuiFormLabel-asterisk {
    color: red;
  }

  ${({ $hasBackground, theme }) =>
    $hasBackground &&
    css`
      background: ${theme.white};
      border-radius: 10px;
      padding: 4px 12px 0px;
    `}

  ${({ $isDisabled, theme }) =>
    $isDisabled &&
    css`
      background: ${theme.grayDark};
      border-radius: 4px;
    `}
`;

export const AreaCheckbox = styled.div`
  .MuiFormControlLabel-root {
    margin: 0;
  }
  .MuiCheckbox-root {
    padding: 0;
  }
  .MuiFormControlLabel-label {
    font-size: 0.8rem;
    margin-left: 2px;
    color: ${({ theme }) => theme.icon};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-left: auto;
  }
`;
